import { createVanIconComponent } from "./van"

const Discount = createVanIconComponent("discount")
export default Discount
